export default ({transaction: {computedDescription = ''} = {}} = {}) =>
  computedDescription;
